export class JsonRPCRequest {
    public jsonrpc: string = "2.0";
    public static createFromJSONString(jsonString: string) {
        const json = JSON.parse(jsonString);
        return new JsonRPCRequest(json.method, json.params, json.id);
    }

    public constructor(public method: string, public params?: any, public id?: string) {}
    public json(): string { return JSON.stringify(this); }

    public get service(): string | undefined { return this.method.split('.')[0] || undefined; }
    public get action(): string | undefined { return this.method.split('.')[1] || undefined; }
}

export class JsonRPCResponse {
    public jsonrpc: string = "2.0";
    public constructor(public result: any, public id: string) {}
    public json(): string { return JSON.stringify(this); }
}

export class JsonRPCService {
    private static _instance?: JsonRPCService;

    public static getInstance(): JsonRPCService {
        if (!JsonRPCService._instance) JsonRPCService._instance = new JsonRPCService();
        return JsonRPCService._instance;
    }

    public createRequest(method: string, params?: any): JsonRPCRequest {
        const id = Math.random().toString(36).slice(2, 12);
        return new JsonRPCRequest(method, params, id);
    }

    public createNotification(method: string, params?: any): JsonRPCRequest {
        return new JsonRPCRequest(method, params);
    }
}
